import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=5b6a2bb2&scoped=true"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=5b6a2bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a2bb2",
  null
  
)

export default component.exports